// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: v6GVasCmjcoJpKZhA57bGQ
// Component: bMGUQ9TxBPsJI
import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import Button from "../../Button"; // plasmic-import: NxycUbS85IVXb2/component

import { useScreenVariants as useScreenVariantshQ7Ab2TDfxBfTk } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: hQ7AB2tDFXBfTk/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_mechz.module.css"; // plasmic-import: v6GVasCmjcoJpKZhA57bGQ/projectcss
import sty from "./PlasmicHomepage.module.css"; // plasmic-import: bMGUQ9TxBPsJI/css

import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: kmDjyMAgVxdWnp/icon
import Icon4Icon from "./icons/PlasmicIcon__Icon4"; // plasmic-import: 3m4uVCB_20TDjx/icon
import _227601RightArrowIconsvgIcon from "./icons/PlasmicIcon___227601RightArrowIconsvg"; // plasmic-import: 28ccL-rkNGYuT4/icon
import mechz1186X80Png48Ym0AsJt from "./images/mechz1186X80Png.png"; // plasmic-import: 48YM0ASJt/picture
import mechzVert1Png2MsKyBn0 from "./images/mechzVert1Png2.png"; // plasmic-import: MsKyBn__0/picture
import l1PngKGpz85Lvr from "./images/l1Png.png"; // plasmic-import: kGPZ85lvr/picture
import l22Bvihr7Nkd from "./images/l22.png"; // plasmic-import: Bvihr7nkd/picture
import l3LfCaLiLJ from "./images/l3.png"; // plasmic-import: LFCaLi_lJ/picture
import l4M6DL76Plw from "./images/l4.png"; // plasmic-import: M6dL76plw/picture
import mechzAction2Gif2YdfyGchLz from "./images/mechzAction2Gif2.gif"; // plasmic-import: YdfyGchLz/picture
import image7FlN99ZYSevQePk from "./images/image7.png"; // plasmic-import: FlN99zYSevQEPk/picture
import collectMechzFKwvr8G3O from "./images/collectMechz.png"; // plasmic-import: FKwvr8g3O/picture
import image481AQlsDnuyhwX8 from "./images/image4.png"; // plasmic-import: 81AQlsDnuyhwX8/picture
import icons8TwittersvgW5ZvFLoqAuH8Zu from "./images/icons8Twittersvg.svg"; // plasmic-import: w5ZvFLoqAuH8zu/picture
import icons8Facebooksvg2X2E0IGuunMaBs from "./images/icons8Facebooksvg.svg"; // plasmic-import: 2X2e0iGuunMaBS/picture
import icons8YoutubesvgSYrq6VrcDciGse from "./images/icons8Youtubesvg.svg"; // plasmic-import: sYRQ6vrcDCIGse/picture
import icons8Vimeosvg9Yh6CNw0Rwm923 from "./images/icons8Vimeosvg.svg"; // plasmic-import: 9Yh6cNw0rwm923/picture

export type PlasmicHomepage__VariantMembers = {};

export type PlasmicHomepage__VariantsArgs = {};
type VariantPropType = keyof PlasmicHomepage__VariantsArgs;
export const PlasmicHomepage__VariantProps = new Array<VariantPropType>();

export type PlasmicHomepage__ArgsType = {};
type ArgPropType = keyof PlasmicHomepage__ArgsType;
export const PlasmicHomepage__ArgProps = new Array<ArgPropType>();

export type PlasmicHomepage__OverridesType = {
  root?: p.Flex<"div">;
  navBar?: p.Flex<"header">;
  logoWrap?: p.Flex<"div">;
  logo?: p.Flex<typeof p.PlasmicImg>;
  navmenu?: p.Flex<"div">;
  link3?: p.Flex<"a">;
  link2?: p.Flex<"a">;
  link4?: p.Flex<"a">;
  navBarButtonBlock?: p.Flex<"div">;
  startPlayButton?: p.Flex<typeof Button>;
  btnText?: p.Flex<"div">;
  section1?: p.Flex<"section">;
  container?: p.Flex<"div">;
  flexBox?: p.Flex<"div">;
  bannerImage?: p.Flex<"div">;
  contentBlock?: p.Flex<"div">;
  mainHeading?: p.Flex<"h1">;
  peraBanner?: p.Flex<"p">;
  playGameButton?: p.Flex<typeof Button>;
  section2?: p.Flex<"section">;
  subHeading?: p.Flex<"h2">;
  logoContainer?: p.Flex<"div">;
  section3?: p.Flex<"section">;
  twoSideBox?: p.Flex<"div">;
  subHeading2?: p.Flex<"h2">;
  peraContent?: p.Flex<"p">;
  unorderList?: p.Flex<"ul">;
  listIteam?: p.Flex<"li">;
  listIteam3?: p.Flex<"li">;
  listIteam4?: p.Flex<"li">;
  listIteam5?: p.Flex<"li">;
  listIteam6?: p.Flex<"li">;
  listIteam7?: p.Flex<"li">;
  playButton?: p.Flex<typeof Button>;
  bannerImage2?: p.Flex<"div">;
  imageMarketing2?: p.Flex<typeof p.PlasmicImg>;
  section4?: p.Flex<"section">;
  testimonialText?: p.Flex<"h2">;
  position?: p.Flex<"p">;
  section5?: p.Flex<"section">;
  twoSidedContent?: p.Flex<"div">;
  subHeading3?: p.Flex<"h2">;
  line2?: p.Flex<"div">;
  ol?: p.Flex<"ol">;
  section6?: p.Flex<"section">;
  twoSideBox2?: p.Flex<"div">;
  subHeading4?: p.Flex<"h2">;
  peraContent2?: p.Flex<"p">;
  unorderList2?: p.Flex<"ul">;
  listIteam2?: p.Flex<"li">;
  listIteam9?: p.Flex<"li">;
  listIteam10?: p.Flex<"li">;
  listIteam11?: p.Flex<"li">;
  listIteam12?: p.Flex<"li">;
  listIteam13?: p.Flex<"li">;
  playNowButton?: p.Flex<typeof Button>;
  bannerImage3?: p.Flex<"div">;
  imageMarketing3?: p.Flex<typeof p.PlasmicImg>;
  section7?: p.Flex<"section">;
  subHeading5?: p.Flex<"h2">;
  line3?: p.Flex<"div">;
  blockChapterContent?: p.Flex<"div">;
  blockChapterContent4?: p.Flex<"div">;
  blockChapterContent2?: p.Flex<"div">;
  blockChapterContent3?: p.Flex<"div">;
  section8?: p.Flex<"section">;
  avtarContent?: p.Flex<"div">;
  avatarImage?: p.Flex<"div">;
  section9?: p.Flex<"section">;
  button?: p.Flex<typeof Button>;
  svg?: p.Flex<"svg">;
  footer?: p.Flex<"footer">;
  footerLogo?: p.Flex<"div">;
  logo2?: p.Flex<typeof p.PlasmicImg>;
  footerLink?: p.Flex<"a">;
  footerLink4?: p.Flex<"a">;
  footerLink5?: p.Flex<"a">;
  copyRight?: p.Flex<"p">;
  socialIcons?: p.Flex<"div">;
  twitter?: p.Flex<typeof p.PlasmicImg>;
  facebook?: p.Flex<typeof p.PlasmicImg>;
  youtube?: p.Flex<typeof p.PlasmicImg>;
  vimeo?: p.Flex<typeof p.PlasmicImg>;
};

export interface DefaultHomepageProps {
  className?: string;
}

function PlasmicHomepage__RenderFunc(props: {
  variants: PlasmicHomepage__VariantsArgs;
  args: PlasmicHomepage__ArgsType;
  overrides: PlasmicHomepage__OverridesType;

  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(
    () =>
      Object.assign(
        {},

        props.args
      ),
    [props.args]
  );

  const $props = args;

  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantshQ7Ab2TDfxBfTk()
  });

  return (
    <React.Fragment>
      {}

      {}

      <div className={projectcss.plasmic_page_wrapper}>
        <p.Stack
          as={"div"}
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          hasGap={true}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            sty.root
          )}
        >
          <header
            data-plasmic-name={"navBar"}
            data-plasmic-override={overrides.navBar}
            className={classNames(projectcss.all, sty.navBar)}
          >
            <div
              data-plasmic-name={"logoWrap"}
              data-plasmic-override={overrides.logoWrap}
              className={classNames(projectcss.all, sty.logoWrap)}
            >
              <p.PlasmicImg
                data-plasmic-name={"logo"}
                data-plasmic-override={overrides.logo}
                alt={""}
                className={classNames(sty.logo)}
                displayHeight={"auto" as const}
                displayMaxHeight={"none" as const}
                displayMaxWidth={"220px" as const}
                displayMinHeight={"0" as const}
                displayMinWidth={"0" as const}
                displayWidth={"auto" as const}
                loading={"lazy" as const}
                src={{
                  src: mechz1186X80Png48Ym0AsJt,
                  fullWidth: 186,
                  fullHeight: 80,
                  aspectRatio: undefined
                }}
              />
            </div>

            {true ? (
              <div
                data-plasmic-name={"navmenu"}
                data-plasmic-override={overrides.navmenu}
                className={classNames(projectcss.all, sty.navmenu)}
              >
                <a
                  data-plasmic-name={"link3"}
                  data-plasmic-override={overrides.link3}
                  className={classNames(
                    projectcss.all,
                    projectcss.a,
                    projectcss.__wab_text,
                    sty.link3
                  )}
                  href={"/" as const}
                >
                  {"Home"}
                </a>

                <a
                  data-plasmic-name={"link2"}
                  data-plasmic-override={overrides.link2}
                  className={classNames(
                    projectcss.all,
                    projectcss.a,
                    projectcss.__wab_text,
                    sty.link2
                  )}
                  href={"#" as const}
                >
                  {"Story"}
                </a>

                <a
                  data-plasmic-name={"link4"}
                  data-plasmic-override={overrides.link4}
                  className={classNames(
                    projectcss.all,
                    projectcss.a,
                    projectcss.__wab_text,
                    sty.link4
                  )}
                  href={
                    "https://objkt.com/collection/KT1K58hY9q4ckHnb1KGXB2XgbM49EXZTWPBy" as const
                  }
                >
                  {"Store"}
                </a>
              </div>
            ) : null}

            <div
              data-plasmic-name={"navBarButtonBlock"}
              data-plasmic-override={overrides.navBarButtonBlock}
              className={classNames(projectcss.all, sty.navBarButtonBlock)}
            >
              <Button
                data-plasmic-name={"startPlayButton"}
                data-plasmic-override={overrides.startPlayButton}
                className={classNames("__wab_instance", sty.startPlayButton)}
                color={"blue" as const}
                link={"/play" as const}
                shape={"rounded" as const}
              >
                <div
                  data-plasmic-name={"btnText"}
                  data-plasmic-override={overrides.btnText}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.btnText
                  )}
                >
                  {"Start Playing"}
                </div>
              </Button>
            </div>
          </header>

          <section
            data-plasmic-name={"section1"}
            data-plasmic-override={overrides.section1}
            className={classNames(projectcss.all, sty.section1)}
          >
            <div
              data-plasmic-name={"container"}
              data-plasmic-override={overrides.container}
              className={classNames(projectcss.all, sty.container)}
            >
              <p.Stack
                as={"div"}
                data-plasmic-name={"flexBox"}
                data-plasmic-override={overrides.flexBox}
                hasGap={true}
                className={classNames(projectcss.all, sty.flexBox)}
              >
                <div className={classNames(projectcss.all, sty.column__qu6Jm)}>
                  <div
                    data-plasmic-name={"bannerImage"}
                    data-plasmic-override={overrides.bannerImage}
                    className={classNames(projectcss.all, sty.bannerImage)}
                  >
                    <p.PlasmicImg
                      alt={""}
                      className={classNames(sty.img__rcv4N)}
                      displayHeight={"auto" as const}
                      displayMaxHeight={"none" as const}
                      displayMaxWidth={"100%" as const}
                      displayMinHeight={"0" as const}
                      displayMinWidth={"0" as const}
                      displayWidth={"auto" as const}
                      loading={"lazy" as const}
                      src={{
                        src: mechzVert1Png2MsKyBn0,
                        fullWidth: 511,
                        fullHeight: 973,
                        aspectRatio: undefined
                      }}
                    />
                  </div>
                </div>

                <div className={classNames(projectcss.all, sty.column__rVnyS)}>
                  <div
                    data-plasmic-name={"contentBlock"}
                    data-plasmic-override={overrides.contentBlock}
                    className={classNames(projectcss.all, sty.contentBlock)}
                  >
                    <h1
                      data-plasmic-name={"mainHeading"}
                      data-plasmic-override={overrides.mainHeading}
                      className={classNames(
                        projectcss.all,
                        projectcss.h1,
                        projectcss.__wab_text,
                        sty.mainHeading
                      )}
                    >
                      {"The First Play-To-Earn \nMech Game on Blockchain"}
                    </h1>

                    <p
                      data-plasmic-name={"peraBanner"}
                      data-plasmic-override={overrides.peraBanner}
                      className={classNames(
                        projectcss.all,
                        projectcss.p,
                        sty.peraBanner
                      )}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__jpy6S
                        )}
                      >
                        <React.Fragment>
                          <React.Fragment>
                            {"Pilot your own mech in this sci-fi adventure. "}
                          </React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span"
                            }
                            style={{ fontWeight: 700 }}
                          >
                            {"Mechz "}
                          </span>
                          <React.Fragment>
                            {
                              "is the first open-world play-to-earn Mechanized Combat Adventure game. \n\nIt uses the Tezos blockchain and wallet to let players keep their loot and trade with others. As the game expands, the world will grow along with the adventure. So get an Experimental Fuel Cell  and "
                            }
                          </React.Fragment>
                          <span
                            className={
                              "plasmic_default__all plasmic_default__span"
                            }
                            style={{ fontWeight: 700 }}
                          >
                            {"mount up to Mechz!"}
                          </span>
                          <React.Fragment>{""}</React.Fragment>
                        </React.Fragment>
                      </div>
                    </p>

                    {true ? (
                      <div
                        className={classNames(
                          projectcss.all,
                          sty.freeBox___9V5Y5
                        )}
                      >
                        <Button
                          data-plasmic-name={"playGameButton"}
                          data-plasmic-override={overrides.playGameButton}
                          className={classNames(
                            "__wab_instance",
                            sty.playGameButton
                          )}
                          color={"softBlue" as const}
                          link={"/play" as const}
                          shape={"rounded" as const}
                          showEndIcon={true}
                        >
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__aJrBk
                            )}
                          >
                            {"Play the Game"}
                          </div>
                        </Button>
                      </div>
                    ) : null}
                  </div>
                </div>
              </p.Stack>
            </div>
          </section>

          <p.Stack
            as={"section"}
            data-plasmic-name={"section2"}
            data-plasmic-override={overrides.section2}
            hasGap={true}
            className={classNames(projectcss.all, sty.section2)}
          >
            <h2
              data-plasmic-name={"subHeading"}
              data-plasmic-override={overrides.subHeading}
              className={classNames(
                projectcss.all,
                projectcss.h2,
                projectcss.__wab_text,
                sty.subHeading
              )}
            >
              {"Inspired by:"}
            </h2>

            <p.Stack
              as={"div"}
              data-plasmic-name={"logoContainer"}
              data-plasmic-override={overrides.logoContainer}
              hasGap={true}
              className={classNames(projectcss.all, sty.logoContainer)}
            >
              <p.PlasmicImg
                alt={""}
                className={classNames(sty.img__bNAuf)}
                displayHeight={
                  hasVariant(globalVariants, "screen", "mobileOnly")
                    ? ("auto" as const)
                    : ("auto" as const)
                }
                displayMaxHeight={"none" as const}
                displayMaxWidth={"100%" as const}
                displayMinHeight={"0" as const}
                displayMinWidth={"0" as const}
                displayWidth={
                  hasVariant(globalVariants, "screen", "mobileOnly")
                    ? ("100px" as const)
                    : ("180px" as const)
                }
                loading={"lazy" as const}
                src={{
                  src: l1PngKGpz85Lvr,
                  fullWidth: 175,
                  fullHeight: 122,
                  aspectRatio: undefined
                }}
              />

              <p.PlasmicImg
                alt={""}
                className={classNames(sty.img__l6QpB)}
                displayHeight={
                  hasVariant(globalVariants, "screen", "mobileOnly")
                    ? ("auto" as const)
                    : ("auto" as const)
                }
                displayMaxHeight={"none" as const}
                displayMaxWidth={"100%" as const}
                displayMinHeight={"0" as const}
                displayMinWidth={"0" as const}
                displayWidth={
                  hasVariant(globalVariants, "screen", "mobileOnly")
                    ? ("100px" as const)
                    : ("180px" as const)
                }
                loading={"lazy" as const}
                src={{
                  src: l22Bvihr7Nkd,
                  fullWidth: 175,
                  fullHeight: 122,
                  aspectRatio: undefined
                }}
              />

              <p.PlasmicImg
                alt={""}
                className={classNames(sty.img__rKoQa)}
                displayHeight={
                  hasVariant(globalVariants, "screen", "mobileOnly")
                    ? ("auto" as const)
                    : ("auto" as const)
                }
                displayMaxHeight={"none" as const}
                displayMaxWidth={"100%" as const}
                displayMinHeight={"0" as const}
                displayMinWidth={"0" as const}
                displayWidth={
                  hasVariant(globalVariants, "screen", "mobileOnly")
                    ? ("120px" as const)
                    : ("157px" as const)
                }
                loading={"lazy" as const}
                src={{
                  src: l3LfCaLiLJ,
                  fullWidth: 175,
                  fullHeight: 122,
                  aspectRatio: undefined
                }}
              />

              <p.PlasmicImg
                alt={""}
                className={classNames(sty.img__l6Ey)}
                displayHeight={
                  hasVariant(globalVariants, "screen", "mobileOnly")
                    ? ("auto" as const)
                    : ("auto" as const)
                }
                displayMaxHeight={"none" as const}
                displayMaxWidth={"100%" as const}
                displayMinHeight={"0" as const}
                displayMinWidth={"0" as const}
                displayWidth={
                  hasVariant(globalVariants, "screen", "mobileOnly")
                    ? ("100px" as const)
                    : ("164.999px" as const)
                }
                loading={"lazy" as const}
                src={{
                  src: l4M6DL76Plw,
                  fullWidth: 175,
                  fullHeight: 122,
                  aspectRatio: undefined
                }}
              />
            </p.Stack>
          </p.Stack>

          <section
            data-plasmic-name={"section3"}
            data-plasmic-override={overrides.section3}
            className={classNames(projectcss.all, sty.section3)}
          >
            <div
              data-plasmic-name={"twoSideBox"}
              data-plasmic-override={overrides.twoSideBox}
              className={classNames(projectcss.all, sty.twoSideBox)}
            >
              {(
                hasVariant(globalVariants, "screen", "mobileOnly") ? true : true
              ) ? (
                <div className={classNames(projectcss.all, sty.freeBox__dFpUx)}>
                  {(
                    hasVariant(globalVariants, "screen", "mobileOnly")
                      ? true
                      : true
                  ) ? (
                    <div
                      className={classNames(projectcss.all, sty.freeBox__gsgIm)}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          sty.columns___9LyyH
                        )}
                      >
                        <div
                          className={classNames(
                            projectcss.all,
                            sty.column__oYsq
                          )}
                        >
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__qZoqQ
                            )}
                          >
                            <h2
                              data-plasmic-name={"subHeading2"}
                              data-plasmic-override={overrides.subHeading2}
                              className={classNames(
                                projectcss.all,
                                projectcss.h2,
                                sty.subHeading2
                              )}
                            >
                              <div
                                className={classNames(
                                  projectcss.all,
                                  projectcss.__wab_text,
                                  sty.text___6VWl6
                                )}
                              >
                                {"Action Packed \nMech Battles"}
                              </div>

                              <p
                                data-plasmic-name={"peraContent"}
                                data-plasmic-override={overrides.peraContent}
                                className={classNames(
                                  projectcss.all,
                                  projectcss.p,
                                  projectcss.__wab_text,
                                  sty.peraContent
                                )}
                              >
                                {"Be the pilot of your own Mech:"}
                              </p>

                              <ul
                                data-plasmic-name={"unorderList"}
                                data-plasmic-override={overrides.unorderList}
                                className={classNames(
                                  projectcss.all,
                                  projectcss.ul,
                                  sty.unorderList
                                )}
                              >
                                <li
                                  data-plasmic-name={"listIteam"}
                                  data-plasmic-override={overrides.listIteam}
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.li,
                                    projectcss.__wab_text,
                                    sty.listIteam
                                  )}
                                >
                                  {"Collect Character Skins"}
                                </li>

                                <li
                                  data-plasmic-name={"listIteam3"}
                                  data-plasmic-override={overrides.listIteam3}
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.li,
                                    projectcss.__wab_text,
                                    sty.listIteam3
                                  )}
                                >
                                  {"Collect Weapons"}
                                </li>

                                <li
                                  data-plasmic-name={"listIteam4"}
                                  data-plasmic-override={overrides.listIteam4}
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.li,
                                    projectcss.__wab_text,
                                    sty.listIteam4
                                  )}
                                >
                                  {"Duel for Prizes\n"}
                                </li>

                                <li
                                  data-plasmic-name={"listIteam5"}
                                  data-plasmic-override={overrides.listIteam5}
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.li,
                                    projectcss.__wab_text,
                                    sty.listIteam5
                                  )}
                                >
                                  {"Create and Join Factions"}
                                </li>

                                <li
                                  data-plasmic-name={"listIteam6"}
                                  data-plasmic-override={overrides.listIteam6}
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.li,
                                    projectcss.__wab_text,
                                    sty.listIteam6
                                  )}
                                >
                                  {"Discover New Planets\n"}
                                </li>

                                <li
                                  data-plasmic-name={"listIteam7"}
                                  data-plasmic-override={overrides.listIteam7}
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.li,
                                    projectcss.__wab_text,
                                    sty.listIteam7
                                  )}
                                >
                                  {"Meet New C\nharacters"}
                                </li>
                              </ul>
                            </h2>
                          </div>

                          <Button
                            data-plasmic-name={"playButton"}
                            data-plasmic-override={overrides.playButton}
                            className={classNames(
                              "__wab_instance",
                              sty.playButton
                            )}
                            color={"softBlue" as const}
                            link={"/play" as const}
                            shape={"rounded" as const}
                            showEndIcon={true}
                          >
                            <div
                              className={classNames(
                                projectcss.all,
                                projectcss.__wab_text,
                                sty.text__rlNnk
                              )}
                            >
                              {"Start Playing"}
                            </div>
                          </Button>
                        </div>

                        <div
                          className={classNames(
                            projectcss.all,
                            sty.column___49PUp
                          )}
                        >
                          <div
                            data-plasmic-name={"bannerImage2"}
                            data-plasmic-override={overrides.bannerImage2}
                            className={classNames(
                              projectcss.all,
                              sty.bannerImage2
                            )}
                          >
                            <p.PlasmicImg
                              data-plasmic-name={"imageMarketing2"}
                              data-plasmic-override={overrides.imageMarketing2}
                              alt={""}
                              className={classNames(sty.imageMarketing2)}
                              displayHeight={
                                hasVariant(
                                  globalVariants,
                                  "screen",
                                  "mobileOnly"
                                )
                                  ? ("auto" as const)
                                  : ("500px" as const)
                              }
                              displayMaxHeight={"none" as const}
                              displayMaxWidth={"100%" as const}
                              displayMinHeight={"0" as const}
                              displayMinWidth={"0" as const}
                              displayWidth={
                                hasVariant(
                                  globalVariants,
                                  "screen",
                                  "mobileOnly"
                                )
                                  ? ("400px" as const)
                                  : ("511px" as const)
                              }
                              loading={"lazy" as const}
                              src={{
                                src: mechzAction2Gif2YdfyGchLz,
                                fullWidth: 320,
                                fullHeight: 240,
                                aspectRatio: undefined
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
              ) : null}
            </div>
          </section>

          {true ? (
            <section
              data-plasmic-name={"section4"}
              data-plasmic-override={overrides.section4}
              className={classNames(projectcss.all, sty.section4)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__mbGrv)}>
                <div className={classNames(projectcss.all, sty.columns__f8BpB)}>
                  <div
                    className={classNames(projectcss.all, sty.column___98FV)}
                  >
                    <p.PlasmicImg
                      alt={""}
                      className={classNames(sty.img__ivmAp)}
                      displayHeight={"256px" as const}
                      displayMaxHeight={"none" as const}
                      displayMaxWidth={"100%" as const}
                      displayMinHeight={"0" as const}
                      displayMinWidth={"0" as const}
                      displayWidth={"256px" as const}
                      loading={"lazy" as const}
                      src={{
                        src: image7FlN99ZYSevQePk,
                        fullWidth: 1112,
                        fullHeight: 794,
                        aspectRatio: undefined
                      }}
                    />
                  </div>

                  <div
                    className={classNames(projectcss.all, sty.column___3WIzk)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox___8TpS)}
                    >
                      <h2
                        data-plasmic-name={"testimonialText"}
                        data-plasmic-override={overrides.testimonialText}
                        className={classNames(
                          projectcss.all,
                          projectcss.h2,
                          projectcss.__wab_text,
                          sty.testimonialText
                        )}
                      >
                        {
                          "“This course is a must-take for anyone in digital marketing. Worth every penny.”"
                        }
                      </h2>

                      <p
                        data-plasmic-name={"position"}
                        data-plasmic-override={overrides.position}
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.position
                        )}
                      >
                        {"Jane Doe, Sr. Marketing Manager at Company"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          ) : null}

          <section
            data-plasmic-name={"section5"}
            data-plasmic-override={overrides.section5}
            className={classNames(projectcss.all, sty.section5)}
          >
            <div
              data-plasmic-name={"twoSidedContent"}
              data-plasmic-override={overrides.twoSidedContent}
              className={classNames(projectcss.all, sty.twoSidedContent)}
            >
              <h2
                data-plasmic-name={"subHeading3"}
                data-plasmic-override={overrides.subHeading3}
                className={classNames(
                  projectcss.all,
                  projectcss.h2,
                  projectcss.__wab_text,
                  sty.subHeading3
                )}
              >
                {"RoadMap"}
              </h2>

              <div
                data-plasmic-name={"line2"}
                data-plasmic-override={overrides.line2}
                className={classNames(projectcss.all, sty.line2)}
              />

              <p.Stack
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.columns__kZfnA)}
              >
                <div className={classNames(projectcss.all, sty.column__hu1Ko)}>
                  <h2
                    className={classNames(
                      projectcss.all,
                      projectcss.h2,
                      projectcss.__wab_text,
                      sty.h2__lPnqz
                    )}
                  >
                    <React.Fragment>
                      <React.Fragment>{""}</React.Fragment>
                      {
                        <ol
                          data-plasmic-name={"ol"}
                          data-plasmic-override={overrides.ol}
                          className={classNames(
                            projectcss.all,
                            projectcss.ol,
                            sty.ol
                          )}
                        >
                          <li
                            className={classNames(
                              projectcss.all,
                              projectcss.li,
                              projectcss.__wab_text,
                              sty.li__c3HMv
                            )}
                          >
                            {"Experimental Fuel Cell"}
                          </li>
                        </ol>
                      }
                      <React.Fragment>{""}</React.Fragment>
                    </React.Fragment>
                  </h2>

                  <p
                    className={classNames(
                      projectcss.all,
                      projectcss.p,
                      projectcss.__wab_text,
                      sty.p__vLVg8
                    )}
                  >
                    {
                      "The first major bit of functionality will be to allow certain VIPs, influencers and whales to get early access to the game world. So our first NFT is the Experimental Fuel Cell. When purchased, the owner will be able to board a mech and play Mechz."
                    }
                  </p>
                </div>

                <div className={classNames(projectcss.all, sty.column__ljdfR)}>
                  <h2
                    className={classNames(
                      projectcss.all,
                      projectcss.h2,
                      projectcss.__wab_text,
                      sty.h2__fQi8T
                    )}
                  >
                    {"2. Unlock Classes"}
                  </h2>

                  <p
                    className={classNames(
                      projectcss.all,
                      projectcss.p,
                      projectcss.__wab_text,
                      sty.p___32Moj
                    )}
                  >
                    {
                      "Our next NFTs will be a series of characters that will allow you to change your hero's appearance and even add special skills. The character NFTs will be dropped over a period of time as they are revealed. "
                    }
                  </p>
                </div>

                <div className={classNames(projectcss.all, sty.column__sr4Hq)}>
                  <h2
                    className={classNames(
                      projectcss.all,
                      projectcss.h2,
                      projectcss.__wab_text,
                      sty.h2__srzcq
                    )}
                  >
                    {"3. Unlock Worlds "}
                  </h2>

                  <p
                    className={classNames(
                      projectcss.all,
                      projectcss.p,
                      projectcss.__wab_text,
                      sty.p__voM7V
                    )}
                  >
                    {
                      "The open-world nature of Mechz contributes to secret and exclusive areas that are unlocked with Game World NFTs. These can be won by playing Mechz or purchased. "
                    }
                  </p>
                </div>

                <div className={classNames(projectcss.all, sty.column__dZO7)}>
                  <h2
                    className={classNames(
                      projectcss.all,
                      projectcss.h2,
                      projectcss.__wab_text,
                      sty.h2__dSmkB
                    )}
                  >
                    {"4. Unlock Missions"}
                  </h2>

                  <p
                    className={classNames(
                      projectcss.all,
                      projectcss.p,
                      projectcss.__wab_text,
                      sty.p__n48EA
                    )}
                  >
                    {
                      "Mechz will have special missions that can only be accessed by holding special mission NFTs. These will primarily be collaborations with other artists on Tezos. "
                    }
                  </p>
                </div>

                <div className={classNames(projectcss.all, sty.column__wjDJ)}>
                  <h2
                    className={classNames(
                      projectcss.all,
                      projectcss.h2,
                      projectcss.__wab_text,
                      sty.h2___4Xecy
                    )}
                  >
                    {"5. Buy Land"}
                  </h2>

                  <p
                    className={classNames(
                      projectcss.all,
                      projectcss.p,
                      projectcss.__wab_text,
                      sty.p__qWrUo
                    )}
                  >
                    {
                      "As the game world expands, we'll offer players the opportunity to own a part of Mechz. Players can purchase open land as well as existing shops and locations. The land will offer customization of the game world through blockchain ownership."
                    }
                  </p>
                </div>

                <div className={classNames(projectcss.all, sty.column___26Elz)}>
                  <h2
                    className={classNames(
                      projectcss.all,
                      projectcss.h2,
                      projectcss.__wab_text,
                      sty.h2___8MlV2
                    )}
                  >
                    {"6. Factions"}
                  </h2>

                  <p
                    className={classNames(
                      projectcss.all,
                      projectcss.p,
                      projectcss.__wab_text,
                      sty.p___7K1S7
                    )}
                  >
                    {
                      "The next thing we'll bring players of Mechz is the ability to join factions. Each faction will have a special reward and unique missions. Factions will encourage teamwork and collaboration. "
                    }
                  </p>
                </div>
              </p.Stack>
            </div>
          </section>

          <section
            data-plasmic-name={"section6"}
            data-plasmic-override={overrides.section6}
            className={classNames(projectcss.all, sty.section6)}
          >
            <div
              data-plasmic-name={"twoSideBox2"}
              data-plasmic-override={overrides.twoSideBox2}
              className={classNames(projectcss.all, sty.twoSideBox2)}
            >
              <div className={classNames(projectcss.all, sty.columns__ihQh)}>
                <div className={classNames(projectcss.all, sty.column__l4Dt)}>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__vUd1Y)}
                  >
                    <h2
                      data-plasmic-name={"subHeading4"}
                      data-plasmic-override={overrides.subHeading4}
                      className={classNames(
                        projectcss.all,
                        projectcss.h2,
                        sty.subHeading4
                      )}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text___8GiWq
                        )}
                      >
                        {"Collect Everything"}
                      </div>

                      <p
                        data-plasmic-name={"peraContent2"}
                        data-plasmic-override={overrides.peraContent2}
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.peraContent2
                        )}
                      >
                        {"You can Win, Buy and Sell almost Everything in Mechz"}
                      </p>

                      <ul
                        data-plasmic-name={"unorderList2"}
                        data-plasmic-override={overrides.unorderList2}
                        className={classNames(
                          projectcss.all,
                          projectcss.ul,
                          sty.unorderList2
                        )}
                      >
                        <li
                          data-plasmic-name={"listIteam2"}
                          data-plasmic-override={overrides.listIteam2}
                          className={classNames(
                            projectcss.all,
                            projectcss.li,
                            projectcss.__wab_text,
                            sty.listIteam2
                          )}
                        >
                          {"Characters and Skins"}
                        </li>

                        <li
                          data-plasmic-name={"listIteam9"}
                          data-plasmic-override={overrides.listIteam9}
                          className={classNames(
                            projectcss.all,
                            projectcss.li,
                            projectcss.__wab_text,
                            sty.listIteam9
                          )}
                        >
                          {"Weapons\n"}
                        </li>

                        <li
                          data-plasmic-name={"listIteam10"}
                          data-plasmic-override={overrides.listIteam10}
                          className={classNames(
                            projectcss.all,
                            projectcss.li,
                            projectcss.__wab_text,
                            sty.listIteam10
                          )}
                        >
                          {"Faction Items\n"}
                        </li>

                        <li
                          data-plasmic-name={"listIteam11"}
                          data-plasmic-override={overrides.listIteam11}
                          className={classNames(
                            projectcss.all,
                            projectcss.li,
                            projectcss.__wab_text,
                            sty.listIteam11
                          )}
                        >
                          {"Decorations\n"}
                        </li>

                        <li
                          data-plasmic-name={"listIteam12"}
                          data-plasmic-override={overrides.listIteam12}
                          className={classNames(
                            projectcss.all,
                            projectcss.li,
                            projectcss.__wab_text,
                            sty.listIteam12
                          )}
                        >
                          {"Consumable Items"}
                        </li>

                        <li
                          data-plasmic-name={"listIteam13"}
                          data-plasmic-override={overrides.listIteam13}
                          className={classNames(
                            projectcss.all,
                            projectcss.li,
                            projectcss.__wab_text,
                            sty.listIteam13
                          )}
                        >
                          {"Land"}
                        </li>
                      </ul>
                    </h2>
                  </div>

                  <Button
                    data-plasmic-name={"playNowButton"}
                    data-plasmic-override={overrides.playNowButton}
                    className={classNames("__wab_instance", sty.playNowButton)}
                    color={"softBlue" as const}
                    link={"/play" as const}
                    shape={"rounded" as const}
                    showEndIcon={true}
                  >
                    {"Start Playing"}
                  </Button>
                </div>

                <div className={classNames(projectcss.all, sty.column__dCvDz)}>
                  <div
                    data-plasmic-name={"bannerImage3"}
                    data-plasmic-override={overrides.bannerImage3}
                    className={classNames(projectcss.all, sty.bannerImage3)}
                  >
                    <p.PlasmicImg
                      data-plasmic-name={"imageMarketing3"}
                      data-plasmic-override={overrides.imageMarketing3}
                      alt={""}
                      className={classNames(sty.imageMarketing3)}
                      displayHeight={
                        hasVariant(globalVariants, "screen", "mobileOnly")
                          ? ("auto" as const)
                          : ("100%" as const)
                      }
                      displayMaxHeight={"none" as const}
                      displayMaxWidth={"100%" as const}
                      displayMinHeight={"0" as const}
                      displayMinWidth={"0" as const}
                      displayWidth={
                        hasVariant(globalVariants, "screen", "mobileOnly")
                          ? ("400px" as const)
                          : ("100%" as const)
                      }
                      loading={"lazy" as const}
                      src={{
                        src: collectMechzFKwvr8G3O,
                        fullWidth: 611,
                        fullHeight: 364,
                        aspectRatio: undefined
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>

          {true ? (
            <section
              data-plasmic-name={"section7"}
              data-plasmic-override={overrides.section7}
              className={classNames(projectcss.all, sty.section7)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__l35Lu)}>
                <h2
                  data-plasmic-name={"subHeading5"}
                  data-plasmic-override={overrides.subHeading5}
                  className={classNames(
                    projectcss.all,
                    projectcss.h2,
                    projectcss.__wab_text,
                    sty.subHeading5
                  )}
                >
                  {"Who should take this course?"}
                </h2>

                <div
                  data-plasmic-name={"line3"}
                  data-plasmic-override={overrides.line3}
                  className={classNames(projectcss.all, sty.line3)}
                />
              </div>

              <p.Stack
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.columns__ebkQe)}
              >
                <div className={classNames(projectcss.all, sty.column__dWfi)}>
                  <div
                    data-plasmic-name={"blockChapterContent"}
                    data-plasmic-override={overrides.blockChapterContent}
                    className={classNames(
                      projectcss.all,
                      sty.blockChapterContent
                    )}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text___1Sma6
                      )}
                    >
                      {"Marketers"}
                    </div>

                    <li
                      className={classNames(
                        projectcss.all,
                        projectcss.li,
                        projectcss.__wab_text,
                        sty.li___2GwhW
                      )}
                    >
                      {"Learn how all of the marketing pieces fit together"}
                    </li>

                    <li
                      className={classNames(
                        projectcss.all,
                        projectcss.li,
                        projectcss.__wab_text,
                        sty.li__lnuFl
                      )}
                    >
                      {"Master digital marketing for any business"}
                    </li>

                    <li
                      className={classNames(
                        projectcss.all,
                        projectcss.li,
                        projectcss.__wab_text,
                        sty.li__opBzL
                      )}
                    >
                      {"Get access to marketing gurus and their tips"}
                    </li>

                    <li
                      className={classNames(
                        projectcss.all,
                        projectcss.li,
                        projectcss.__wab_text,
                        sty.li__wjLXi
                      )}
                    >
                      {"Prepare killer presentations and collateral"}
                    </li>
                  </div>
                </div>

                <div className={classNames(projectcss.all, sty.column__y9BbI)}>
                  <div
                    data-plasmic-name={"blockChapterContent4"}
                    data-plasmic-override={overrides.blockChapterContent4}
                    className={classNames(
                      projectcss.all,
                      sty.blockChapterContent4
                    )}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__zeAof
                      )}
                    >
                      {"Product managers"}
                    </div>

                    <li
                      className={classNames(
                        projectcss.all,
                        projectcss.li,
                        projectcss.__wab_text,
                        sty.li__oJo4K
                      )}
                    >
                      {"Understand the context of your product work"}
                    </li>

                    <li
                      className={classNames(
                        projectcss.all,
                        projectcss.li,
                        projectcss.__wab_text,
                        sty.li___4KYXg
                      )}
                    >
                      {"Learn how to segment your audience properly"}
                    </li>

                    <li
                      className={classNames(
                        projectcss.all,
                        projectcss.li,
                        projectcss.__wab_text,
                        sty.li___2DEs9
                      )}
                    >
                      {"Implement brand voice and style in your work"}
                    </li>

                    <li
                      className={classNames(
                        projectcss.all,
                        projectcss.li,
                        projectcss.__wab_text,
                        sty.li__xwvuP
                      )}
                    >
                      {"Connect top of funnel activities with your flow"}
                    </li>
                  </div>
                </div>

                <div className={classNames(projectcss.all, sty.column__c6MBw)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__orXT
                    )}
                  >
                    {"Designers"}
                  </div>

                  <li
                    className={classNames(
                      projectcss.all,
                      projectcss.li,
                      sty.li__m7N
                    )}
                  >
                    <li
                      className={classNames(
                        projectcss.all,
                        projectcss.li,
                        projectcss.__wab_text,
                        sty.li__z8DDh
                      )}
                    >
                      {"Learn how your design can inspire action"}
                    </li>

                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__wbsPt
                      )}
                    >
                      {"Gain big picture insights that affect design"}
                    </div>

                    <div
                      data-plasmic-name={"blockChapterContent2"}
                      data-plasmic-override={overrides.blockChapterContent2}
                      className={classNames(
                        projectcss.all,
                        sty.blockChapterContent2
                      )}
                    >
                      <li
                        className={classNames(
                          projectcss.all,
                          projectcss.li,
                          projectcss.__wab_text,
                          sty.li__iMg74
                        )}
                      >
                        {"Make advertisements that convert"}
                      </li>

                      <li
                        className={classNames(
                          projectcss.all,
                          projectcss.li,
                          projectcss.__wab_text,
                          sty.li___4BoSo
                        )}
                      >
                        {"Create digital assets for the right audience"}
                      </li>
                    </div>
                  </li>
                </div>

                <div className={classNames(projectcss.all, sty.column__fOtW9)}>
                  <div
                    data-plasmic-name={"blockChapterContent3"}
                    data-plasmic-override={overrides.blockChapterContent3}
                    className={classNames(
                      projectcss.all,
                      sty.blockChapterContent3
                    )}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__dxjlr
                      )}
                    >
                      {"Business owners"}
                    </div>

                    <li
                      className={classNames(
                        projectcss.all,
                        projectcss.li,
                        projectcss.__wab_text,
                        sty.li__tlZx
                      )}
                    >
                      {"Kickstart your marketing plan and efforts"}
                    </li>

                    <li
                      className={classNames(
                        projectcss.all,
                        projectcss.li,
                        projectcss.__wab_text,
                        sty.li__djFQn
                      )}
                    >
                      {"Upgrade your brand, website and social media"}
                    </li>

                    <li
                      className={classNames(
                        projectcss.all,
                        projectcss.li,
                        projectcss.__wab_text,
                        sty.li__bgdDm
                      )}
                    >
                      {"Prepare effective collateral for your business"}
                    </li>

                    <li
                      className={classNames(
                        projectcss.all,
                        projectcss.li,
                        projectcss.__wab_text,
                        sty.li__wRimx
                      )}
                    >
                      {"Start advertising your company online"}
                    </li>
                  </div>
                </div>
              </p.Stack>
            </section>
          ) : null}

          {true ? (
            <section
              data-plasmic-name={"section8"}
              data-plasmic-override={overrides.section8}
              className={classNames(projectcss.all, sty.section8)}
            >
              <div className={classNames(projectcss.all, sty.columns__qwq7Y)}>
                <div className={classNames(projectcss.all, sty.column__yVqEh)}>
                  <div
                    data-plasmic-name={"avtarContent"}
                    data-plasmic-override={overrides.avtarContent}
                    className={classNames(projectcss.all, sty.avtarContent)}
                  >
                    <h2
                      className={classNames(
                        projectcss.all,
                        projectcss.h2,
                        projectcss.__wab_text,
                        sty.h2__ikbmD
                      )}
                    >
                      {"About the instructor"}
                    </h2>

                    <p
                      className={classNames(
                        projectcss.all,
                        projectcss.p,
                        projectcss.__wab_text,
                        sty.p__giu9B
                      )}
                    >
                      {"Jane Doe, Title"}
                    </p>

                    <p
                      className={classNames(
                        projectcss.all,
                        projectcss.p,
                        projectcss.__wab_text,
                        sty.p__ibvYk
                      )}
                    >
                      {
                        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                      }
                    </p>

                    <p
                      className={classNames(
                        projectcss.all,
                        projectcss.p,
                        projectcss.__wab_text,
                        sty.p__rUe9D
                      )}
                    >
                      {
                        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                      }
                    </p>

                    <p
                      className={classNames(
                        projectcss.all,
                        projectcss.p,
                        projectcss.__wab_text,
                        sty.p__kBtTn
                      )}
                    >
                      {
                        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                      }
                    </p>
                  </div>
                </div>

                <div className={classNames(projectcss.all, sty.column__kPvu3)}>
                  <div
                    data-plasmic-name={"avatarImage"}
                    data-plasmic-override={overrides.avatarImage}
                    className={classNames(projectcss.all, sty.avatarImage)}
                  >
                    <p.PlasmicImg
                      alt={""}
                      className={classNames(sty.img__ol1XC)}
                      displayHeight={
                        hasVariant(globalVariants, "screen", "mobileOnly")
                          ? ("100%" as const)
                          : ("auto" as const)
                      }
                      displayMaxHeight={"none" as const}
                      displayMaxWidth={"100%" as const}
                      displayMinHeight={"0" as const}
                      displayMinWidth={"0" as const}
                      displayWidth={
                        hasVariant(globalVariants, "screen", "mobileOnly")
                          ? ("400px" as const)
                          : ("auto" as const)
                      }
                      loading={"lazy" as const}
                      src={{
                        src: image481AQlsDnuyhwX8,
                        fullWidth: 930,
                        fullHeight: 1162,
                        aspectRatio: undefined
                      }}
                    />
                  </div>
                </div>
              </div>
            </section>
          ) : null}

          {true ? (
            <section
              data-plasmic-name={"section9"}
              data-plasmic-override={overrides.section9}
              className={classNames(projectcss.all, sty.section9)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__mOIcO)}>
                <h2
                  className={classNames(
                    projectcss.all,
                    projectcss.h2,
                    projectcss.__wab_text,
                    sty.h2__u2Vs3
                  )}
                >
                  {"Access the course today"}
                </h2>
              </div>

              <Button
                data-plasmic-name={"button"}
                data-plasmic-override={overrides.button}
                className={classNames("__wab_instance", sty.button)}
                color={"white" as const}
                endIcon={
                  <_227601RightArrowIconsvgIcon
                    data-plasmic-name={"svg"}
                    data-plasmic-override={overrides.svg}
                    className={classNames(projectcss.all, sty.svg)}
                    role={"img"}
                  />
                }
                shape={"rounded" as const}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__ma9A
                  )}
                >
                  {"Access the course"}
                </div>
              </Button>
            </section>
          ) : null}

          <footer
            data-plasmic-name={"footer"}
            data-plasmic-override={overrides.footer}
            className={classNames(projectcss.all, sty.footer)}
          >
            <div className={classNames(projectcss.all, sty.columns__uOaW2)}>
              <div className={classNames(projectcss.all, sty.column___1KJiH)}>
                <div
                  data-plasmic-name={"footerLogo"}
                  data-plasmic-override={overrides.footerLogo}
                  className={classNames(projectcss.all, sty.footerLogo)}
                >
                  <p.PlasmicImg
                    data-plasmic-name={"logo2"}
                    data-plasmic-override={overrides.logo2}
                    alt={""}
                    className={classNames(sty.logo2)}
                    displayHeight={"auto" as const}
                    displayMaxHeight={"none" as const}
                    displayMaxWidth={"100%" as const}
                    displayMinHeight={"0" as const}
                    displayMinWidth={"0" as const}
                    displayWidth={"300px" as const}
                    loading={"lazy" as const}
                    src={{
                      src: mechz1186X80Png48Ym0AsJt,
                      fullWidth: 186,
                      fullHeight: 80,
                      aspectRatio: undefined
                    }}
                  />
                </div>
              </div>

              <div className={classNames(projectcss.all, sty.column__jf5ZN)}>
                <h3
                  className={classNames(
                    projectcss.all,
                    projectcss.h3,
                    projectcss.__wab_text,
                    sty.h3__supUm
                  )}
                >
                  {"Company"}
                </h3>

                <a
                  data-plasmic-name={"footerLink"}
                  data-plasmic-override={overrides.footerLink}
                  className={classNames(
                    projectcss.all,
                    projectcss.a,
                    projectcss.__wab_text,
                    sty.footerLink
                  )}
                  href={"/" as const}
                >
                  {"Story"}
                </a>
              </div>

              <div className={classNames(projectcss.all, sty.column__uZrl3)}>
                <h3
                  className={classNames(
                    projectcss.all,
                    projectcss.h3,
                    projectcss.__wab_text,
                    sty.h3__zLkBu
                  )}
                >
                  {"Legal"}
                </h3>

                <a
                  data-plasmic-name={"footerLink4"}
                  data-plasmic-override={overrides.footerLink4}
                  className={classNames(
                    projectcss.all,
                    projectcss.a,
                    projectcss.__wab_text,
                    sty.footerLink4
                  )}
                  href={"/" as const}
                >
                  {"Terms & Conditions"}
                </a>

                <a
                  data-plasmic-name={"footerLink5"}
                  data-plasmic-override={overrides.footerLink5}
                  className={classNames(
                    projectcss.all,
                    projectcss.a,
                    projectcss.__wab_text,
                    sty.footerLink5
                  )}
                  href={"/" as const}
                >
                  {"Privacy Policy"}
                </a>
              </div>
            </div>
          </footer>

          <div className={classNames(projectcss.all, sty.freeBox___0Gkl)}>
            <div className={classNames(projectcss.all, sty.columns__k8Dch)}>
              <div className={classNames(projectcss.all, sty.column__ixSXi)}>
                <p
                  data-plasmic-name={"copyRight"}
                  data-plasmic-override={overrides.copyRight}
                  className={classNames(
                    projectcss.all,
                    projectcss.p,
                    projectcss.__wab_text,
                    sty.copyRight
                  )}
                >
                  {"© Blockchain Alchemy. All rights reserved. "}
                </p>
              </div>

              {true ? (
                <div className={classNames(projectcss.all, sty.column___7GHmn)}>
                  <p.Stack
                    as={"div"}
                    data-plasmic-name={"socialIcons"}
                    data-plasmic-override={overrides.socialIcons}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.socialIcons)}
                  >
                    {true ? (
                      <a
                        className={classNames(
                          projectcss.all,
                          projectcss.a,
                          sty.link__e8N1B
                        )}
                        href={"https://twitter.com/" as const}
                        target={"_blank" as const}
                      >
                        <p.PlasmicImg
                          data-plasmic-name={"twitter"}
                          data-plasmic-override={overrides.twitter}
                          alt={""}
                          className={classNames(sty.twitter)}
                          displayHeight={"auto" as const}
                          displayMaxHeight={"none" as const}
                          displayMaxWidth={"100%" as const}
                          displayMinHeight={"0" as const}
                          displayMinWidth={"0" as const}
                          displayWidth={"30px" as const}
                          loading={"lazy" as const}
                          src={{
                            src: icons8TwittersvgW5ZvFLoqAuH8Zu,
                            fullWidth: 150,
                            fullHeight: 150,
                            aspectRatio: 1
                          }}
                        />
                      </a>
                    ) : null}

                    {true ? (
                      <a
                        className={classNames(
                          projectcss.all,
                          projectcss.a,
                          sty.link___1WCRw
                        )}
                        href={"#" as const}
                        target={"_blank" as const}
                      >
                        <p.PlasmicImg
                          data-plasmic-name={"facebook"}
                          data-plasmic-override={overrides.facebook}
                          alt={""}
                          className={classNames(sty.facebook)}
                          displayHeight={"auto" as const}
                          displayMaxHeight={"none" as const}
                          displayMaxWidth={"100%" as const}
                          displayMinHeight={"0" as const}
                          displayMinWidth={"0" as const}
                          displayWidth={"30px" as const}
                          loading={"lazy" as const}
                          src={{
                            src: icons8Facebooksvg2X2E0IGuunMaBs,
                            fullWidth: 150,
                            fullHeight: 150,
                            aspectRatio: 1
                          }}
                        />
                      </a>
                    ) : null}

                    {true ? (
                      <a
                        className={classNames(
                          projectcss.all,
                          projectcss.a,
                          sty.link__m5NWc
                        )}
                        href={"#" as const}
                        target={"_blank" as const}
                      >
                        <p.PlasmicImg
                          data-plasmic-name={"youtube"}
                          data-plasmic-override={overrides.youtube}
                          alt={""}
                          className={classNames(sty.youtube)}
                          displayHeight={"auto" as const}
                          displayMaxHeight={"none" as const}
                          displayMaxWidth={"100%" as const}
                          displayMinHeight={"0" as const}
                          displayMinWidth={"0" as const}
                          displayWidth={"30px" as const}
                          loading={"lazy" as const}
                          src={{
                            src: icons8YoutubesvgSYrq6VrcDciGse,
                            fullWidth: 150,
                            fullHeight: 150,
                            aspectRatio: 1
                          }}
                        />
                      </a>
                    ) : null}

                    {true ? (
                      <a
                        className={classNames(
                          projectcss.all,
                          projectcss.a,
                          sty.link__rmVsk
                        )}
                        href={"#" as const}
                      >
                        {true ? (
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__rxgph
                            )}
                          >
                            <p.PlasmicImg
                              data-plasmic-name={"vimeo"}
                              data-plasmic-override={overrides.vimeo}
                              alt={""}
                              className={classNames(sty.vimeo)}
                              displayHeight={"auto" as const}
                              displayMaxHeight={"none" as const}
                              displayMaxWidth={"100%" as const}
                              displayMinHeight={"0" as const}
                              displayMinWidth={"0" as const}
                              displayWidth={"30px" as const}
                              loading={"lazy" as const}
                              src={{
                                src: icons8Vimeosvg9Yh6CNw0Rwm923,
                                fullWidth: 150,
                                fullHeight: 150,
                                aspectRatio: 1
                              }}
                            />
                          </div>
                        ) : null}
                      </a>
                    ) : null}
                  </p.Stack>
                </div>
              ) : null}
            </div>
          </div>
        </p.Stack>
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "navBar",
    "logoWrap",
    "logo",
    "navmenu",
    "link3",
    "link2",
    "link4",
    "navBarButtonBlock",
    "startPlayButton",
    "btnText",
    "section1",
    "container",
    "flexBox",
    "bannerImage",
    "contentBlock",
    "mainHeading",
    "peraBanner",
    "playGameButton",
    "section2",
    "subHeading",
    "logoContainer",
    "section3",
    "twoSideBox",
    "subHeading2",
    "peraContent",
    "unorderList",
    "listIteam",
    "listIteam3",
    "listIteam4",
    "listIteam5",
    "listIteam6",
    "listIteam7",
    "playButton",
    "bannerImage2",
    "imageMarketing2",
    "section4",
    "testimonialText",
    "position",
    "section5",
    "twoSidedContent",
    "subHeading3",
    "line2",
    "ol",
    "section6",
    "twoSideBox2",
    "subHeading4",
    "peraContent2",
    "unorderList2",
    "listIteam2",
    "listIteam9",
    "listIteam10",
    "listIteam11",
    "listIteam12",
    "listIteam13",
    "playNowButton",
    "bannerImage3",
    "imageMarketing3",
    "section7",
    "subHeading5",
    "line3",
    "blockChapterContent",
    "blockChapterContent4",
    "blockChapterContent2",
    "blockChapterContent3",
    "section8",
    "avtarContent",
    "avatarImage",
    "section9",
    "button",
    "svg",
    "footer",
    "footerLogo",
    "logo2",
    "footerLink",
    "footerLink4",
    "footerLink5",
    "copyRight",
    "socialIcons",
    "twitter",
    "facebook",
    "youtube",
    "vimeo"
  ],
  navBar: [
    "navBar",
    "logoWrap",
    "logo",
    "navmenu",
    "link3",
    "link2",
    "link4",
    "navBarButtonBlock",
    "startPlayButton",
    "btnText"
  ],
  logoWrap: ["logoWrap", "logo"],
  logo: ["logo"],
  navmenu: ["navmenu", "link3", "link2", "link4"],
  link3: ["link3"],
  link2: ["link2"],
  link4: ["link4"],
  navBarButtonBlock: ["navBarButtonBlock", "startPlayButton", "btnText"],
  startPlayButton: ["startPlayButton", "btnText"],
  btnText: ["btnText"],
  section1: [
    "section1",
    "container",
    "flexBox",
    "bannerImage",
    "contentBlock",
    "mainHeading",
    "peraBanner",
    "playGameButton"
  ],
  container: [
    "container",
    "flexBox",
    "bannerImage",
    "contentBlock",
    "mainHeading",
    "peraBanner",
    "playGameButton"
  ],
  flexBox: [
    "flexBox",
    "bannerImage",
    "contentBlock",
    "mainHeading",
    "peraBanner",
    "playGameButton"
  ],
  bannerImage: ["bannerImage"],
  contentBlock: ["contentBlock", "mainHeading", "peraBanner", "playGameButton"],
  mainHeading: ["mainHeading"],
  peraBanner: ["peraBanner"],
  playGameButton: ["playGameButton"],
  section2: ["section2", "subHeading", "logoContainer"],
  subHeading: ["subHeading"],
  logoContainer: ["logoContainer"],
  section3: [
    "section3",
    "twoSideBox",
    "subHeading2",
    "peraContent",
    "unorderList",
    "listIteam",
    "listIteam3",
    "listIteam4",
    "listIteam5",
    "listIteam6",
    "listIteam7",
    "playButton",
    "bannerImage2",
    "imageMarketing2"
  ],
  twoSideBox: [
    "twoSideBox",
    "subHeading2",
    "peraContent",
    "unorderList",
    "listIteam",
    "listIteam3",
    "listIteam4",
    "listIteam5",
    "listIteam6",
    "listIteam7",
    "playButton",
    "bannerImage2",
    "imageMarketing2"
  ],
  subHeading2: [
    "subHeading2",
    "peraContent",
    "unorderList",
    "listIteam",
    "listIteam3",
    "listIteam4",
    "listIteam5",
    "listIteam6",
    "listIteam7"
  ],
  peraContent: ["peraContent"],
  unorderList: [
    "unorderList",
    "listIteam",
    "listIteam3",
    "listIteam4",
    "listIteam5",
    "listIteam6",
    "listIteam7"
  ],
  listIteam: ["listIteam"],
  listIteam3: ["listIteam3"],
  listIteam4: ["listIteam4"],
  listIteam5: ["listIteam5"],
  listIteam6: ["listIteam6"],
  listIteam7: ["listIteam7"],
  playButton: ["playButton"],
  bannerImage2: ["bannerImage2", "imageMarketing2"],
  imageMarketing2: ["imageMarketing2"],
  section4: ["section4", "testimonialText", "position"],
  testimonialText: ["testimonialText"],
  position: ["position"],
  section5: ["section5", "twoSidedContent", "subHeading3", "line2", "ol"],
  twoSidedContent: ["twoSidedContent", "subHeading3", "line2", "ol"],
  subHeading3: ["subHeading3"],
  line2: ["line2"],
  ol: ["ol"],
  section6: [
    "section6",
    "twoSideBox2",
    "subHeading4",
    "peraContent2",
    "unorderList2",
    "listIteam2",
    "listIteam9",
    "listIteam10",
    "listIteam11",
    "listIteam12",
    "listIteam13",
    "playNowButton",
    "bannerImage3",
    "imageMarketing3"
  ],
  twoSideBox2: [
    "twoSideBox2",
    "subHeading4",
    "peraContent2",
    "unorderList2",
    "listIteam2",
    "listIteam9",
    "listIteam10",
    "listIteam11",
    "listIteam12",
    "listIteam13",
    "playNowButton",
    "bannerImage3",
    "imageMarketing3"
  ],
  subHeading4: [
    "subHeading4",
    "peraContent2",
    "unorderList2",
    "listIteam2",
    "listIteam9",
    "listIteam10",
    "listIteam11",
    "listIteam12",
    "listIteam13"
  ],
  peraContent2: ["peraContent2"],
  unorderList2: [
    "unorderList2",
    "listIteam2",
    "listIteam9",
    "listIteam10",
    "listIteam11",
    "listIteam12",
    "listIteam13"
  ],
  listIteam2: ["listIteam2"],
  listIteam9: ["listIteam9"],
  listIteam10: ["listIteam10"],
  listIteam11: ["listIteam11"],
  listIteam12: ["listIteam12"],
  listIteam13: ["listIteam13"],
  playNowButton: ["playNowButton"],
  bannerImage3: ["bannerImage3", "imageMarketing3"],
  imageMarketing3: ["imageMarketing3"],
  section7: [
    "section7",
    "subHeading5",
    "line3",
    "blockChapterContent",
    "blockChapterContent4",
    "blockChapterContent2",
    "blockChapterContent3"
  ],
  subHeading5: ["subHeading5"],
  line3: ["line3"],
  blockChapterContent: ["blockChapterContent"],
  blockChapterContent4: ["blockChapterContent4"],
  blockChapterContent2: ["blockChapterContent2"],
  blockChapterContent3: ["blockChapterContent3"],
  section8: ["section8", "avtarContent", "avatarImage"],
  avtarContent: ["avtarContent"],
  avatarImage: ["avatarImage"],
  section9: ["section9", "button", "svg"],
  button: ["button", "svg"],
  svg: ["svg"],
  footer: [
    "footer",
    "footerLogo",
    "logo2",
    "footerLink",
    "footerLink4",
    "footerLink5"
  ],
  footerLogo: ["footerLogo", "logo2"],
  logo2: ["logo2"],
  footerLink: ["footerLink"],
  footerLink4: ["footerLink4"],
  footerLink5: ["footerLink5"],
  copyRight: ["copyRight"],
  socialIcons: ["socialIcons", "twitter", "facebook", "youtube", "vimeo"],
  twitter: ["twitter"],
  facebook: ["facebook"],
  youtube: ["youtube"],
  vimeo: ["vimeo"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  typeof PlasmicDescendants[T][number];
type NodeDefaultElementType = {
  root: "div";
  navBar: "header";
  logoWrap: "div";
  logo: typeof p.PlasmicImg;
  navmenu: "div";
  link3: "a";
  link2: "a";
  link4: "a";
  navBarButtonBlock: "div";
  startPlayButton: typeof Button;
  btnText: "div";
  section1: "section";
  container: "div";
  flexBox: "div";
  bannerImage: "div";
  contentBlock: "div";
  mainHeading: "h1";
  peraBanner: "p";
  playGameButton: typeof Button;
  section2: "section";
  subHeading: "h2";
  logoContainer: "div";
  section3: "section";
  twoSideBox: "div";
  subHeading2: "h2";
  peraContent: "p";
  unorderList: "ul";
  listIteam: "li";
  listIteam3: "li";
  listIteam4: "li";
  listIteam5: "li";
  listIteam6: "li";
  listIteam7: "li";
  playButton: typeof Button;
  bannerImage2: "div";
  imageMarketing2: typeof p.PlasmicImg;
  section4: "section";
  testimonialText: "h2";
  position: "p";
  section5: "section";
  twoSidedContent: "div";
  subHeading3: "h2";
  line2: "div";
  ol: "ol";
  section6: "section";
  twoSideBox2: "div";
  subHeading4: "h2";
  peraContent2: "p";
  unorderList2: "ul";
  listIteam2: "li";
  listIteam9: "li";
  listIteam10: "li";
  listIteam11: "li";
  listIteam12: "li";
  listIteam13: "li";
  playNowButton: typeof Button;
  bannerImage3: "div";
  imageMarketing3: typeof p.PlasmicImg;
  section7: "section";
  subHeading5: "h2";
  line3: "div";
  blockChapterContent: "div";
  blockChapterContent4: "div";
  blockChapterContent2: "div";
  blockChapterContent3: "div";
  section8: "section";
  avtarContent: "div";
  avatarImage: "div";
  section9: "section";
  button: typeof Button;
  svg: "svg";
  footer: "footer";
  footerLogo: "div";
  logo2: typeof p.PlasmicImg;
  footerLink: "a";
  footerLink4: "a";
  footerLink5: "a";
  copyRight: "p";
  socialIcons: "div";
  twitter: typeof p.PlasmicImg;
  facebook: typeof p.PlasmicImg;
  youtube: typeof p.PlasmicImg;
  vimeo: typeof p.PlasmicImg;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHomepage__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHomepage__VariantsArgs;
    args?: PlasmicHomepage__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicHomepage__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicHomepage__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicHomepage__ArgProps,
          internalVariantPropNames: PlasmicHomepage__VariantProps
        }),
      [props, nodeName]
    );

    return PlasmicHomepage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicHomepage";
  } else {
    func.displayName = `PlasmicHomepage.${nodeName}`;
  }
  return func;
}

export const PlasmicHomepage = Object.assign(
  // Top-level PlasmicHomepage renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    navBar: makeNodeComponent("navBar"),
    logoWrap: makeNodeComponent("logoWrap"),
    logo: makeNodeComponent("logo"),
    navmenu: makeNodeComponent("navmenu"),
    link3: makeNodeComponent("link3"),
    link2: makeNodeComponent("link2"),
    link4: makeNodeComponent("link4"),
    navBarButtonBlock: makeNodeComponent("navBarButtonBlock"),
    startPlayButton: makeNodeComponent("startPlayButton"),
    btnText: makeNodeComponent("btnText"),
    section1: makeNodeComponent("section1"),
    container: makeNodeComponent("container"),
    flexBox: makeNodeComponent("flexBox"),
    bannerImage: makeNodeComponent("bannerImage"),
    contentBlock: makeNodeComponent("contentBlock"),
    mainHeading: makeNodeComponent("mainHeading"),
    peraBanner: makeNodeComponent("peraBanner"),
    playGameButton: makeNodeComponent("playGameButton"),
    section2: makeNodeComponent("section2"),
    subHeading: makeNodeComponent("subHeading"),
    logoContainer: makeNodeComponent("logoContainer"),
    section3: makeNodeComponent("section3"),
    twoSideBox: makeNodeComponent("twoSideBox"),
    subHeading2: makeNodeComponent("subHeading2"),
    peraContent: makeNodeComponent("peraContent"),
    unorderList: makeNodeComponent("unorderList"),
    listIteam: makeNodeComponent("listIteam"),
    listIteam3: makeNodeComponent("listIteam3"),
    listIteam4: makeNodeComponent("listIteam4"),
    listIteam5: makeNodeComponent("listIteam5"),
    listIteam6: makeNodeComponent("listIteam6"),
    listIteam7: makeNodeComponent("listIteam7"),
    playButton: makeNodeComponent("playButton"),
    bannerImage2: makeNodeComponent("bannerImage2"),
    imageMarketing2: makeNodeComponent("imageMarketing2"),
    section4: makeNodeComponent("section4"),
    testimonialText: makeNodeComponent("testimonialText"),
    position: makeNodeComponent("position"),
    section5: makeNodeComponent("section5"),
    twoSidedContent: makeNodeComponent("twoSidedContent"),
    subHeading3: makeNodeComponent("subHeading3"),
    line2: makeNodeComponent("line2"),
    ol: makeNodeComponent("ol"),
    section6: makeNodeComponent("section6"),
    twoSideBox2: makeNodeComponent("twoSideBox2"),
    subHeading4: makeNodeComponent("subHeading4"),
    peraContent2: makeNodeComponent("peraContent2"),
    unorderList2: makeNodeComponent("unorderList2"),
    listIteam2: makeNodeComponent("listIteam2"),
    listIteam9: makeNodeComponent("listIteam9"),
    listIteam10: makeNodeComponent("listIteam10"),
    listIteam11: makeNodeComponent("listIteam11"),
    listIteam12: makeNodeComponent("listIteam12"),
    listIteam13: makeNodeComponent("listIteam13"),
    playNowButton: makeNodeComponent("playNowButton"),
    bannerImage3: makeNodeComponent("bannerImage3"),
    imageMarketing3: makeNodeComponent("imageMarketing3"),
    section7: makeNodeComponent("section7"),
    subHeading5: makeNodeComponent("subHeading5"),
    line3: makeNodeComponent("line3"),
    blockChapterContent: makeNodeComponent("blockChapterContent"),
    blockChapterContent4: makeNodeComponent("blockChapterContent4"),
    blockChapterContent2: makeNodeComponent("blockChapterContent2"),
    blockChapterContent3: makeNodeComponent("blockChapterContent3"),
    section8: makeNodeComponent("section8"),
    avtarContent: makeNodeComponent("avtarContent"),
    avatarImage: makeNodeComponent("avatarImage"),
    section9: makeNodeComponent("section9"),
    button: makeNodeComponent("button"),
    svg: makeNodeComponent("svg"),
    footer: makeNodeComponent("footer"),
    footerLogo: makeNodeComponent("footerLogo"),
    logo2: makeNodeComponent("logo2"),
    footerLink: makeNodeComponent("footerLink"),
    footerLink4: makeNodeComponent("footerLink4"),
    footerLink5: makeNodeComponent("footerLink5"),
    copyRight: makeNodeComponent("copyRight"),
    socialIcons: makeNodeComponent("socialIcons"),
    twitter: makeNodeComponent("twitter"),
    facebook: makeNodeComponent("facebook"),
    youtube: makeNodeComponent("youtube"),
    vimeo: makeNodeComponent("vimeo"),

    // Metadata about props expected for PlasmicHomepage
    internalVariantProps: PlasmicHomepage__VariantProps,
    internalArgProps: PlasmicHomepage__ArgProps
  }
);

export default PlasmicHomepage;
/* prettier-ignore-end */
